import clsx from "clsx";

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Lädt"
      className={clsx(
        "inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent",
        className,
      )}
    />
  );
}

/** Unbestimmter Fortschrittsbalken für laufende Suchen ohne Prozentwert. */
export function IndeterminateBar({
  className,
  label = "Lädt",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <div
      role="progressbar"
      aria-label={label}
      className={clsx("h-0.5 overflow-hidden rounded-full bg-label-secondary/15", className)}
    >
      <div className="eh-indeterminate-bar h-full w-1/3 rounded-full bg-accent" />
    </div>
  );
}
